/**
 * Product Tab Navigation Component
 *
 * Handles navigation links to product tabs with smooth scrolling and accordion opening.
 */

(() => {
    function registerProductTabNavigation() {
        Alpine.data('productTabNavigation', () => ({
            init() {
                // Handle tab navigation links
                console.log('Product tab navigation initialized');
                this.setupTabNavigation();
            },

            setupTabNavigation() {
                // Add click event listeners to tab navigation links
                document.addEventListener('click', (e) => {
                    const tabLink = e.target.closest('.product-tab-link');
                    if (!tabLink) return;

                    e.preventDefault();

                    console.log('Tab link clicked', tabLink);
                    const tabId = tabLink.dataset.tab;
                    if (tabId) {
                        console.log('Opening tab and scrolling to', tabId);
                        this.openTabAndScroll(tabId);
                    }
                });

                // Handle URL hash navigation on page load
                this.handleHashNavigation();
            },

            openTabAndScroll(tabId) {
                // Find the tab element
                const tabElement = document.getElementById(tabId);
                if (!tabElement) {
                    console.warn(`Tab element with ID "${tabId}" not found`);
                    return;
                }

                // Find the tab header (h2 element with @click)
                const tabHeader = tabElement.querySelector('h2');
                if (!tabHeader) {
                    console.warn('Tab header not found');
                    return;
                }

                // Check if the tab is already open
                const tabContent = tabElement.querySelector('[x-show]');
                const isOpen =
                    tabContent &&
                    !tabContent.hasAttribute('x-cloak') &&
                    tabContent.style.display !== 'none' &&
                    tabContent.offsetHeight > 0;

                if (!isOpen) {
                    // Click the tab header to open it
                    console.log('Clicking tab header to open accordion');
                    tabHeader.click();
                }

                // Wait a bit for the accordion to open, then scroll
                setTimeout(() => {
                    this.smoothScrollToElement(tabElement);
                }, 300);
            },

            smoothScrollToElement(element) {
                const elementRect = element.getBoundingClientRect();
                const absoluteElementTop = elementRect.top + window.pageYOffset;
                const offset = 100; // Offset from top of viewport

                window.scrollTo({
                    top: absoluteElementTop - offset,
                    behavior: 'smooth',
                });
            },

            handleHashNavigation() {
                // Check if there's a hash in the URL on page load
                const hash = window.location.hash;
                if (hash && hash.startsWith('#')) {
                    const tabId = hash.substring(1);

                    // Wait for Alpine.js to initialize
                    setTimeout(() => {
                        this.openTabAndScroll(tabId);
                    }, 500);
                }
            },
        }));
    }

    // Register when Alpine is available
    if (typeof Alpine !== 'undefined' && Alpine.version) {
        registerProductTabNavigation();
    } else {
        document.addEventListener('alpine:init', () => {
            registerProductTabNavigation();
        });
    }
})();
